import { styled } from "@mui/material/styles";

export const Container = styled("div")({
  position: "relative",
});

export const CardContainer = styled("div")({
  width: "100%",
  height: "100%",
  position: "absolute",
  top: 0,
  left: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backdropFilter: "blur(3px)",
  transition: "all ease-in-out 0.5s",
  pointerEvents: "none",
  zIndex: 9999,
});

export const CardContent = styled("div")({
  backgroundColor: "var(--color-background-dragdrop)",
  width: "96%",
  height: "93%",
  border: "4px dashed var(--color-border-dragdrop)",
  borderRadius: "var(--radius-xl)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  gap: "var(--space-2xl)",
  opacity: 0.8,

  "& h2": {
    color: "var(--color-text-primary)",
  },

  "& svg": {
    fill: "var(--color-primary)",
    width: "100%",
    height: "auto",
    maxWidth: "11rem",
  },
});
